@if (locationItems.length > 0) {
  <ul>
    @for (location of locationItems; track location) {
      <li>
        <div class="location-list-item-wrapper">
          <div class="account-location-name">
            {{ location | ndtFullLocation }}
          </div>
          <div class="account-location-name">{{ location.comment }}</div>
          <div class="location-details">
            <span #buttonWrapper>
              <button
                type="button"
                title="Location Number Details"
                mat-icon-button
                (click)="onDetailsClick(location, buttonWrapper)"
                >
                <mat-icon>{{
                  selectedLocation === location.streetName ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
                }}</mat-icon>
              </button>
            </span>
          </div>
          <button type="button" mat-icon-button (click)="onEditClick(location)"><mat-icon>edit</mat-icon></button>
          <button type="button" title="Remove Location" mat-icon-button (click)="onRemoveClick(location)">
            <mat-icon class="remove-btn">close</mat-icon>
          </button>
        </div>
      </li>
    }
  </ul>
} @else {
  <span class="no-locations-label">No Locations added</span>
}
